import Vue from 'vue'
import CookieConsent from './components/CookieConsent'


export const mountVueElement = (id, { config, locale }) => {
    const element = document.querySelector(id)
    if (!element) {
        throw new Error(`The target element "${id}" could not be found`)
    }

    const vueConfig = {
        render: h => h(CookieConsent, {
            props: { config, locale },
        }),
    }

    new Vue(vueConfig).$mount(element)
}

export default mountVueElement
